
import { CheckBoxButton } from "@goodgamestudios/asset-globals";

import { BasicModel } from "@goodgamestudios/core";
import { BasicCustomCursor } from "@goodgamestudios/core";
import { BasicController } from "@goodgamestudios/core";
import { TextFieldHelper } from "@goodgamestudios/core";
import { TextValide } from "@goodgamestudios/core";

import { KeyboardEvent } from "@goodgamestudios/createjs-utilities";
import { Keyboard } from "@goodgamestudios/createjs-utilities";

import { int } from "@goodgamestudios/math-utilities";

import { SFConstants } from "../../../constants/SFConstants";
import { Poker2RankingDataEvent } from "../../../event/Poker2RankingDataEvent";
import { AvatarCardVO } from "../../../gamevo/AvatarCardVO";
import { RankingVO } from "../../../gamevo/RankingVO";
import { Poker2Model } from "../../../model/Poker2Model";
import { InputFieldConstants } from "../../constants/InputFieldConstants";
import { PokerTextHelper } from "../../helper/PokerTextHelper";

import { NumberStringHelper } from "../../../helper/NumberStringHelper";

import MovieClip = createjs.MovieClip;
import Container = createjs.Container;
import Event = createjs.Event;
import FocusEvent = createjs.FocusEvent;
import MouseEvent = createjs.MouseEvent;
import Rectangle = createjs.Rectangle;

export class Poker2RankingTabRanking {
    private MAX_RANKINGLINES: number = 7;
    private MAX_AVATARHOLDERS: number = 5;
    private MAX_AVATARRANK: number = 4;

    private disp: MovieClip; // rankingDialog.mc_ranking
    private selectedRankingLine: Library.PokerInterface.RankingLine;

    private selectedPlayer: number = 0;
    private selectedTableButton: Library.PokerInterface.TabelButton;
    private currentRankingSort: number = 0;
    private playerSearched: string = "";

    /**
     * @param disp
     */
    constructor(disp: MovieClip) {
        this.disp = disp;
        disp.cb_view.selected();
        disp.cd_friends.deselected();
    }

    public applyProperties(): void {
        this.disp.mc_list.txt_sortrank.mouseEnabled = false;
        this.disp.mc_list.txt_sortname.mouseEnabled = false;
        this.disp.mc_list.txt_sortlevel.mouseEnabled = false;
        this.disp.mc_list.txt_sortxp.mouseEnabled = false;
        this.disp.mc_list.txt_sortachievement.mouseEnabled = false;
        this.disp.mc_list.txt_sortchips.mouseEnabled = false;
        this.initTextFields();
        this.propertyHelper();
    }

    private propertyHelper(): void {
        for (var i: number = 0; i < 3; i++) {
            var tableHead: Library.PokerInterface.TabelButton = this.disp.mc_list["sort_" + i] as Library.PokerInterface.TabelButton;
            tableHead.properties = i;
        }
    }

    public initTextFields(): void {
        TextFieldHelper.changeTextFromatSizeByTextWidth(9, this.disp.mc_list.txt_sortrank,
            Poker2Model.languageData.getTextById("dialog_ranking_rank"));
        TextFieldHelper.changeTextFromatSizeByTextWidth(9, this.disp.mc_list.txt_sortname,
            Poker2Model.languageData.getTextById("dialog_ranking_name"));
        TextFieldHelper.changeTextFromatSizeByTextWidth(9, this.disp.mc_list.txt_sortlevel,
            Poker2Model.languageData.getTextById("dialog_ranking_level"));
        TextFieldHelper.changeTextFromatSizeByTextWidth(9, this.disp.mc_list.txt_sortxp,
            Poker2Model.languageData.getTextById("dialog_ranking_xp"));
        TextFieldHelper.changeTextFromatSizeByTextWidth(9, this.disp.mc_list.txt_sortachievement,
            Poker2Model.languageData.getTextById("dialog_ranking_ap"));
        TextFieldHelper.changeTextFromatSizeByTextWidth(9, this.disp.mc_list.txt_sortchips,
            Poker2Model.languageData.getTextById("dialog_ranking_chips"));
        TextFieldHelper.changeTextFromatSizeByTextWidth(9, this.disp.txt_listview,
            Poker2Model.languageData.getTextById("dialog_ranking_listview"));
        TextFieldHelper.changeTextFromatSizeByTextWidth(9, this.disp.txt_title,
            Poker2Model.languageData.getTextById("dialog_ranking_title"));
        this.disp.btn_myrank.label = Poker2Model.languageData.getTextById("dialog_ranking_myrank");
        TextFieldHelper.changeTextFromatSizeByTextWidth(9, this.disp.txt_friends,
            Poker2Model.languageData.getTextById("dialog_ranking_friends"));

        this.disp.mc_list.sort_2.toolTipText = Poker2Model.languageData.getTextById("tooltip_achievementPoints");
        this.disp.mc_list.sort_0.toolTipText = Poker2Model.languageData.getTextById("tooltip_xpPoints");
        this.disp.btn_search.toolTipText = Poker2Model.languageData.getTextById("dialog_ranking_searchPlayer_tt");
    }

    public show(): void {
        if (this.disp.cb_view.isSelected) {
            this.disp.mc_list.visible = true;
            this.disp.mc_avatarcards.visible = false;
        }
        else {
            this.disp.mc_list.visible = false;
            this.disp.mc_avatarcards.visible = true;
        }
        this.controller.addEventListener("changeRankingAvatarData", this.bindFunction(this.onChangeRankingAvatarData));
        this.controller.addEventListener("changeRankingData", this.bindFunction(this.onChangeRankingData));
        this.disp.btn_search.inputField.addEventListener(KeyboardEvent.KEY_DOWN, this.bindFunction(this.onKeyPress));
        this.disp.btn_search.inputField.addEventListener(KeyboardEvent.KEY_UP, this.bindFunction(this.onKeyUP));
        this.disp.btn_search.inputField.addEventListener(FocusEvent.FOCUS_IN, this.bindFunction(this.onEnterSearchPlayer));
        this.disp.btn_search.addEventListener(MouseEvent.CLICK, this.bindFunction(this.btnSearchOnClick));
        this.playerSearched = "";

        TableHeadButtonHelper.setHeadButtonsSizes([0.72, 1.36, 0.64], this.disp.mc_list);

        this.disp.btn_search.inputField.defaultCacheScale = Poker2LayoutManager.GAME_SCALE_FACTOR;
    }

    private onEnterSearchPlayer(event: Event): void {
        this.disp.btn_search.inputField.text = "";
        this.disp.btn_search.inputField.alpha = InputFieldConstants.INPUT_FILLED_ALPHA;
    }

    public hide(): void {
        this.disp.btn_search.inputField.removeEventListener(FocusEvent.FOCUS_IN, this.bindFunction(this.onEnterSearchPlayer));
        this.disp.btn_search.inputField.removeEventListener(KeyboardEvent.KEY_DOWN, this.bindFunction(this.onKeyPress));
        this.disp.btn_search.inputField.removeEventListener(KeyboardEvent.KEY_UP, this.bindFunction(this.onKeyUP));
        this.disp.btn_search.removeEventListener(MouseEvent.CLICK, this.bindFunction(this.btnSearchOnClick));
        this.controller.removeEventListener("changeRankingAvatarData", this.bindFunction(this.onChangeRankingAvatarData));
        this.controller.removeEventListener("changeRankingData", this.bindFunction(this.onChangeRankingData));
    }

    private btnSearchOnClick(event: MouseEvent): void {
        if(!(event.target instanceof createjs.TextField)) {
            this.searchRanking();
        }
    }

    private onKeyUP(event: KeyboardEvent): void {
        if (event.key == Keyboard.ENTER)
            this.disp.btn_search.inputField.text = "";
    }

    private onKeyPress(event: KeyboardEvent): void {
        if (event.key == Keyboard.ENTER)
            this.searchRanking();
    }
    private onChangeRankingData(event: Poker2RankingDataEvent): void {
        this.fillRanking(Poker2Model.rankingData.rankingList, this.playerSearched);
    }
    private onChangeRankingAvatarData(event: Poker2RankingDataEvent): void {
        this.fillRankingAvatar(Poker2Model.rankingData.rankingAvatarList);
    }

    public onClick(event: MouseEvent): void {
        var tabelButton: Library.PokerInterface.TabelButton;
        var firstRank: number = 0;
        var temp: number = 0;

        switch (event.target) {
            case this.disp.cb_view:
            case this.disp.cd_friends:
                this.selectCheckbox(event.target as CheckBoxButton);
                break;
            case this.disp.btn_search:
                this.searchRanking();
                break;
            // mc_list
            case this.disp.mc_list.sort_0:
            case this.disp.mc_list.sort_1:
            case this.disp.mc_list.sort_2:
                tabelButton = event.target as Library.PokerInterface.TabelButton;
                this.activateTableButton(tabelButton);
                this.getRankingList("-1", event.target.properties);
                break;
            case this.disp.mc_list.btn_up:
                if (event.target.properties > 1) {
                    firstRank = int(event.target.properties - this.MAX_RANKINGLINES);
                    if (firstRank < 0)
                        firstRank = 1;
                    this.getRankingList(String(firstRank), this.currentRankingSort);
                }
                break;
            case this.disp.mc_list.btn_down:
                this.getRankingList(event.target.properties + 1 + "", this.currentRankingSort);
                break;

            // mc_avatarcards
            case this.disp.mc_avatarcards.btn_left:
                temp = int(event.target.properties - this.MAX_AVATARHOLDERS);
                if (temp > 0 && temp >= this.MAX_AVATARRANK)
                    this.getRankingAvatarList(String(temp));
                else if (temp == 0 || temp < this.MAX_AVATARRANK)
                    this.getRankingAvatarList(String(this.MAX_AVATARRANK));
                break;
            case this.disp.mc_avatarcards.btn_right:
                if (event.target.properties >= this.MAX_AVATARHOLDERS)
                    this.getRankingAvatarList(event.target.properties + 1 + "");
                break;

            case this.disp.btn_myrank:
                this.showMyRank();
                break;
            default:
                if (instanceOfClass(event.target, "RankingLine")) {
                    var item: Library.PokerInterface.RankingLine = event.target as Library.PokerInterface.RankingLine;
                    this.selectedPlayer = int(item.properties);
                    this.activateRankingLine(item);
                    Poker2RankingDialog.getAvatarCard(this.selectedPlayer);
                }
                if (instanceOfClass(event.target, "RankingCard"))
                    Poker2RankingDialog.getAvatarCard(event.target.properties);
        }
    }

    public onMouseOver(event: MouseEvent): void {
        if (event.target != this.selectedRankingLine)
            (event.target as Library.PokerInterface.RankingLine).mc_background.gotoAndStop(2);
        this.layoutManager.customCursor.setCursorType(BasicCustomCursor.CURSOR_CLICK);
    }

    public onMouseOut(event: MouseEvent): void {
        if (event.target != this.selectedRankingLine)
            (event.target as Library.PokerInterface.RankingLine).mc_background.gotoAndStop(1);
        this.layoutManager.customCursor.setCursorType(BasicCustomCursor.CURSOR_ARROW);
    }

    public changeTab(): void {
        if (this.disp.cb_view.isSelected) {
            this.disp.cb_view.selected();
            this.getRankingList();
        }
        else {
            this.getRankingAvatarList();
        }
        this.disp.btn_search.inputField.text = Poker2Model.languageData.getTextById("dialog_ranking_searchPlayer");
        this.disp.btn_search.inputField.alpha = InputFieldConstants.INPUT_EMPTY_ALPHA;
    }

    private activateTableButton(tabelButton: Library.PokerInterface.TabelButton): void {
        tabelButton.toggleDropDown();
        if (this.selectedTableButton != tabelButton) {
            if (this.selectedTableButton) this.selectedTableButton.deselected();
            this.selectedTableButton = tabelButton;
            this.selectedTableButton.selected();
        }
    }

    private activateRankingLine(table: Library.PokerInterface.RankingLine): void {
        if (this.selectedRankingLine != table) {
            if (this.selectedRankingLine)
                this.selectedRankingLine.mc_background.gotoAndStop(1);
            this.selectedRankingLine = table;
            this.selectedRankingLine.mc_background.gotoAndStop(2);
        }
    }

    public getRankingList(searchParam: string = "-1", sort: number = 0): void {
        this.currentRankingSort = sort;
        var showFriends: number = int((this.disp.cd_friends.isSelected) ? 1 : 0);
        var paramObject: any = { search: searchParam, sort: sort, showFriends: showFriends };
        BasicModel.smartfoxClient.sendMessage("ral", [JSON.stringify(paramObject)]);
    }

    public searchRanking(): void {
        if (TextValide.isSmartFoxValide(this.disp.btn_search.inputField.text) && this.disp.btn_search.inputField.text != Poker2Model.languageData.getTextById("dialog_ranking_searchPlayer")) {
            if (this.disp.cb_view.isSelected) {
                this.playerSearched = this.disp.btn_search.inputField.text;
                this.getRankingList(this.disp.btn_search.inputField.text, this.currentRankingSort);
            }
            else {
                this.playerSearched = this.disp.btn_search.inputField.text;
                this.getRankingAvatarList(this.disp.btn_search.inputField.text);
            }
        }
    }

    private selectCheckbox(checkbox: CheckBoxButton): void {
        if (checkbox.isSelected)
            checkbox.deselected();
        else
            checkbox.selected();

        if (this.disp.cb_view.isSelected)
            this.getRankingList();
        else
            this.getRankingAvatarList();
    }

    private showMyRank(): void {
        if (this.disp.cb_view.isSelected)
            this.getRankingList(Poker2Model.userData.userName, this.currentRankingSort);
        else
            this.getRankingAvatarList(Poker2Model.userData.userName);
    }

    /**
     * @param rankingList
     * @param playerSearched
     */
    public fillRanking(rankingList: RankingVO[], playerSearched: string): void {
        this.disp.mc_list.visible = true;
        this.disp.mc_avatarcards.visible = false;
        this.selectedRankingLine = null;
        for (var i: number = 0; i < this.MAX_RANKINGLINES; i++) {
            var tItem: Library.PokerInterface.RankingLine = this.disp.mc_list["line" + i] as Library.PokerInterface.RankingLine;
            if (rankingList.length - 1 < i) {
                tItem.visible = false;
                continue;
            }
            tItem.mc_background.gotoAndStop(1);
            if (i == 0)
                this.disp.mc_list.btn_up.properties = rankingList[i].rank;
            if (i == this.MAX_RANKINGLINES - 1)
                this.disp.mc_list.btn_down.properties = rankingList[i].rank;
            tItem.visible = true;
            tItem.properties = rankingList[i].playerId;

            if (rankingList[i].playerId == Poker2Model.userData.playerID || (rankingList[i].name.toLowerCase() == playerSearched.toLowerCase()) || rankingList[i].rank == (int)(playerSearched)) {
                tItem.mc_background.gotoAndStop(2);
                this.selectedRankingLine = tItem;
            }
            tItem.txt_tables_0.text = NumberStringHelper.groupString(rankingList[i].rank, Poker2Model.languageData.getTextById.bind(Poker2Model.languageData));
            tItem.txt_tables_1.text = rankingList[i].name;
            tItem.txt_tables_2.text = NumberStringHelper.groupString(rankingList[i].level, Poker2Model.languageData.getTextById.bind(Poker2Model.languageData));
            tItem.txt_tables_3.text = PokerTextHelper.getShortGroupNumberString(rankingList[i].xp);
            tItem.txt_tables_5.text = PokerTextHelper.getShortGroupNumberString(rankingList[i].chips);
            tItem.txt_tables_4.text = NumberStringHelper.groupString(rankingList[i].acPoints, Poker2Model.languageData.getTextById.bind(Poker2Model.languageData));
            tItem.mouseChildren = false;
        }
    }

    //
    // getter & setter
    //

    protected get layoutManager(): Poker2LayoutManager {
        return Poker2LayoutManager.getInstance();
    }
    protected get controller(): BasicController {
        return BasicController.getInstance();
    }

    //
    // avatar
    //

    public getRankingAvatarList(searchParam: string = "-1"): void {
        var showFriends: number = int((this.disp.cd_friends.isSelected) ? 1 : 0);
        var paramObject: any = { search: searchParam, showFriends: showFriends };
        BasicModel.smartfoxClient.sendMessage("raa", [JSON.stringify(paramObject)]);
    }

    private fillRankingAvatar(rankingAvatarList: AvatarCardVO[]): void {
        this.disp.mc_avatarcards.visible = true;
        this.disp.mc_list.visible = false;
        this.hiderankingCards();
        var avatarHolders: number = 0;
        if (rankingAvatarList.length < this.MAX_AVATARHOLDERS) {
            avatarHolders = int(rankingAvatarList.length);
        }
        else
            avatarHolders = this.MAX_AVATARHOLDERS;
        for (var i: number = 0; i < avatarHolders; i++) {
            var playerCard: Library.PokerInterface.RankingCard = this.disp.mc_avatarcards["mc_card" + i] as Library.PokerInterface.RankingCard;
            playerCard.visible = true;
            playerCard.txt_name.text = rankingAvatarList[i].name;
            playerCard.txt_xp.text = PokerTextHelper.getShortGroupNumberString(rankingAvatarList[i].xp);
            playerCard.txt_chips.text = PokerTextHelper.getShortGroupNumberString(rankingAvatarList[i].chips);
            TextFieldHelper.changeTextFromatSizeByTextWidth(11, playerCard.txt_rank, NumberStringHelper.groupString(rankingAvatarList[i].rank, Poker2Model.languageData.getTextById.bind(Poker2Model.languageData)));
            playerCard.txt_level.text = NumberStringHelper.groupString(rankingAvatarList[i].level, Poker2Model.languageData.getTextById.bind(Poker2Model.languageData));
            playerCard.properties = rankingAvatarList[i].id;
            playerCard.mc_avatar.mouseEnabled = false;
            playerCard.mc_bg.mouseEnabled = true;
            playerCard.mouseChildren = false;
            if (rankingAvatarList[i].id == Poker2Model.userData.playerID || (rankingAvatarList[i].name.toLowerCase() == this.playerSearched.toLowerCase()) || rankingAvatarList[i].rank == (int)(this.playerSearched))
                playerCard.mc_bg.gotoAndStop(2);
            else
                playerCard.mc_bg.gotoAndStop(1);

            if (i == 0)
                this.disp.mc_avatarcards.btn_left.properties = rankingAvatarList[i].rank;
            else if (i == this.MAX_AVATARHOLDERS - 1)
                this.disp.mc_avatarcards.btn_right.properties = rankingAvatarList[i].rank;
            while (playerCard.mc_avatar.numChildren > 0)
                playerCard.mc_avatar.removeChildAt(0);
            var mcAvatar: Container = AvatarHelper.drawAvatarByItemArray(Poker2Model.avatarData.getAvatarClothesArray(rankingAvatarList[i].avatar));
            /// var mcAvatar:Sprite = new AvatarHolder( rankingAvatarList[i].avatar ) as Sprite;
            var bounds: Rectangle = mcAvatar.getBounds(null);

            var scaleFactor: number = (150 / bounds.width);
            if ((bounds.height * scaleFactor) > 100)
                scaleFactor = (100 / bounds.height);
            mcAvatar.scaleX = mcAvatar.scaleY = scaleFactor;
            mcAvatar.x = - ((bounds.width * scaleFactor) / 2 + (bounds.left * scaleFactor));
            mcAvatar.y = - ((bounds.height * scaleFactor) / 4 + (bounds.top * scaleFactor));
            mcAvatar.mouseEnabled = false;
            playerCard.mc_avatar.addChild(mcAvatar);
        }
        this.playerSearched = "";
    }

    private hiderankingCards(): void {
        for (var i: number = 0; i < this.MAX_AVATARHOLDERS; i++) {
            var playerCard: Library.PokerInterface.RankingCard = this.disp.mc_avatarcards["mc_card" + i] as Library.PokerInterface.RankingCard;
            playerCard.visible = false;
        }
    }

    //
    // ende
    //
}
import { Poker2RankingDialog } from "../../dialogs/ranking/Poker2RankingDialog";
import { AvatarHelper } from "../../helper/AvatarHelper";
import { Poker2LayoutManager } from "../../Poker2LayoutManager";

import { instanceOfClass } from "@goodgamestudios/createjs-utilities";
import {TableHeadButtonHelper} from "../../helper/TableHeadButtonHelper";
